class HandlerToManagersApprovalForm {
  constructor(
    enableConfigsField,
    organizationField,
    approvingWaitingTimeField,
    eventRequiringApprovalFieldHandlers = []
  ) {
    this.enableConfigsField = enableConfigsField;
    this.organizationField = organizationField;
    this.approvingWaitingTimeField = approvingWaitingTimeField;
    this.eventRequiringApprovalFieldHandlers = eventRequiringApprovalFieldHandlers;
  }

  eventHandlerToEnableConfigsField = (event) => {
    if (event.target.checked) {
      this.enableNoDependentFields();
      this.enableDependentFields();
    } else {
      this.disableAllFields();
    }
  }

  addEventListenerToEnableConfigsField = () => {
    this.enableConfigsField.input.addEventListener('change', this.eventHandlerToEnableConfigsField);
  }

  eventHandlerToOrganizationField = (clearReasonsLookups) => {
    this.eventRequiringApprovalFieldHandlers.forEach((handler) => {
      if (clearReasonsLookups) {
        handler.clearField();
      }
      handler.forceNoResult(this.organizationField.isEmpty());
    });
  }

  eventHandlerForChangingOrganization = () => {
    const organizationValue = this.organizationField.getValue();
    let clearReasonsLookups = false;
    if (organizationValue && organizationValue.id) {
      clearReasonsLookups = organizationValue.id !== this.previousOrganizationId;
      this.previousOrganizationId = organizationValue.id;
    }
    this.eventHandlerToOrganizationField(clearReasonsLookups);
  }

  addEventListenerToOrganizationField = () => {
    this.organizationField.input.addEventListener('input', this.eventHandlerToOrganizationField);
    this.organizationField.input.addEventListener('blur', this.eventHandlerToOrganizationField);
    this.organizationField.addListenerToAfterSelectRow(this.eventHandlerForChangingOrganization);
  }

  enableDependentFields = () => {
    this.eventRequiringApprovalFieldHandlers.forEach((handler) => {
      handler.enableDependentFields();
    });
  }

  enableNoDependentFields = () => {
    this.eventRequiringApprovalFieldHandlers.forEach((handler) => {
      handler.enableNoDependentFields();
    });
  }

  disableAllFields = () => {
    this.eventRequiringApprovalFieldHandlers.forEach((handler) => {
      handler.disableAllFields();
    });
  }

  validation = () => {

    const errorMessages = [];

    if (this.enableConfigsField.input.checked) {
      const hasValidSections = this.eventRequiringApprovalFieldHandlers.some((handler) => {
        const validation = handler.validation();
        return validation.isValid === true;
      });
      if (!hasValidSections) {
        errorMessages.push(Monet.Form.Messages.mountErrorMessageObject('ManagerApprConfig.reasonRequired'));
      }
    }

    return {
      'isValid': errorMessages.length === 0,
      'errorMessages': errorMessages
    }
  }

  init = () => {
    this.eventRequiringApprovalFieldHandlers.forEach((handler) => {
      handler.init();
    });
    this.addEventListenerToEnableConfigsField();
    this.eventHandlerToOrganizationField();
    this.addEventListenerToOrganizationField();
    const enableConfigsFieldIsChecked = this.enableConfigsField.getValue();
    if (enableConfigsFieldIsChecked) {
      this.enableNoDependentFields();
      this.enableDependentFields();
    } else {
      this.disableAllFields();
    }
  }

}

class HandlerToEventRequiringApprovalFields {
  constructor(enableReasonsFields = {}, lookupListField, enableAllReasonsField) {
    this.enableReasonsFields = enableReasonsFields;
    this.lookupListField = lookupListField;
    this.enableAllReasonsField = enableAllReasonsField;
  }

  eventHandlerToEnableAllReasonsField = (event) => {
    const input = event.target;
    if (input.checked) {
      this.lookupListField.disableAll();
    } else {
      this.lookupListField.enableAll();
    }
  }

  eventHandlerToEnableReasonsField = (event) => {
    if (event && event.target.checked) {
      this.enableDependentFields();
    } else {
      this.disableDependentFields();
    }
  }

  addEventListenerToEnableAllReasonsField = () => {
    this.enableAllReasonsField.input.addEventListener('change', this.eventHandlerToEnableAllReasonsField)
  }

  addEventListenerToEnableReasonsFields = () => {
    for (let prop in this.enableReasonsFields) {
      const input = this.enableReasonsFields[prop].input;
      input.addEventListener('change', this.eventHandlerToEnableReasonsField);
    }
  }

  clearField = () => {
    this.lookupListField.clear();
  }

  forceNoResult = (organizationIsEmpty) => {
    if (organizationIsEmpty) {
      this.lookupListField.setCustomExecuteFilter(() => {
        const dataProvider = App.Forms[this.lookupListField.nameSpace].dataProvider;
        dataProvider.beginUpdate();
        dataProvider.setData([]);
        dataProvider.endUpdate();
        Monet.Grid.Utils.showGridNoResult(this.lookupListField.nameSpace);
      });
    } else {
      Monet.Grid.Utils.hideGridNoResult(this.lookupListField.nameSpace);
      this.lookupListField.setCustomExecuteFilter(null);
    }
    this.lookupListField.hideContainer();
  }

  enableDependentFields = () => {
    const enableReasonsFieldIsChecked = this.enableReasonsFieldIsChecked();
    const enableAllReasonsFieldIsChecked = this.enableAllReasonsField.getValue();
    const isToEnableLookupField = enableReasonsFieldIsChecked && !enableAllReasonsFieldIsChecked;
    const isToEnableEnableAllReasonsField = enableReasonsFieldIsChecked;
    if (isToEnableLookupField) {
      this.lookupListField.enableAll();
    }
    if (isToEnableEnableAllReasonsField) {
      this.enableAllReasonsField.enable();
    }
  }

  disableDependentFields = () => {
    const enableReasonsFieldIsChecked = this.enableReasonsFieldIsChecked();
    const enableAllReasonsFieldIsChecked = this.enableAllReasonsField.getValue();
    const isToDisableLookupField = !enableReasonsFieldIsChecked || enableAllReasonsFieldIsChecked;
    const isToDisableEnableAllReasonsField = !enableReasonsFieldIsChecked;
    if (isToDisableLookupField) {
      this.lookupListField.disableAll();
    }
    if (isToDisableEnableAllReasonsField) {
      this.enableAllReasonsField.disable();
      this.enableAllReasonsField.setChecked(false);
    }
  }

  enableNoDependentFields = () => {
    for (let prop in this.enableReasonsFields) {
      this.enableReasonsFields[prop].enable();
    }
  }

  disableAllFields = () => {
    for (let prop in this.enableReasonsFields) {
      this.enableReasonsFields[prop].disable();
    }
    this.lookupListField.disableAll();
    this.enableAllReasonsField.disable();
  }

  enableReasonsFieldIsChecked = () => {
    return Object.keys(this.enableReasonsFields).some((fieldName) => {
      const isChecked = this.enableReasonsFields[fieldName].getValue();
      return isChecked;
    });
  }

  validation = () => {

    let isValid = false;

    const enableReasonsIsValid = (Object.keys(this.enableReasonsFields).filter((key) => {
      return this.enableReasonsFields[key].getValue() && key;
    }).length > 0);

    const lookupListFieldIsEnabled = !this.lookupListField.input.disabled;

    if (lookupListFieldIsEnabled) {
      const lookupListFieldIsValid = this.lookupListField.isEmpty() === false;
      if (lookupListFieldIsValid) {
        isValid = true;
      }
    } else if (enableReasonsIsValid) {
      isValid = true;
    }

    return {
      'isValid': isValid
    }
  }

  init() {
    this.addEventListenerToEnableAllReasonsField();
    this.addEventListenerToEnableReasonsFields();
    const enableReasonsFieldIsChecked = this.enableReasonsFieldIsChecked();
    if (enableReasonsFieldIsChecked) {
      this.enableDependentFields();
    } else {
      this.disableDependentFields();
    }
  }

}

/* Model */
class ManagersApprovalRequestConfigurationModel extends App.Models.BaseModel {
  modelUrl = 'ManagersApprovalRequestConfiguration';
}

App.Models.ManagersApprovalRequestConfiguration = ManagersApprovalRequestConfigurationModel;

/* Collection */
class ManagersApprovalRequestConfigurationCollection extends App.Collections.BaseCollection {
  url = 'ManagersApprovalRequestConfiguration';
  model = App.Models.ManagersApprovalRequestConfiguration;
}

App.Collections.ManagersApprovalRequestConfigurations = ManagersApprovalRequestConfigurationCollection;

/* Router */
class ManagersApprovalRequestConfigurationRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = 'ManagersApprovalRequestConfiguration';
    const model = App.Models.ManagersApprovalRequestConfiguration;
    const collectionClass = App.Collections.ManagersApprovalRequestConfigurations;

    super(entityName, model, collectionClass);
  }

  afterPopulateForm = function () {
    App.Forms.ManagersApprovalRequestConfiguration.managersApprovalFormHandler.init();
  };

  afterCreateForm = function () {
    const fields = App.Forms.ManagersApprovalRequestConfiguration.form.fields;
    const {
      enableConfigs,
      organization,
      approvingWaitingTime,
      enableReasonsToCancelAStop,
      enableReasonsToCancelAllStops,
      reasonsToCancelStops,
      enableAllReasonsToCancelStops,
      enableReasonsToUndeliverable,
      reasonsToUndeliverable,
      enableAllReasonsToUndeliverable,
      enableReasonsToRedelivery,
      reasonsToRedelivery,
      enableAllReasonsToRedelivery
    } = fields;

    const managersApprovalFormHandler = new HandlerToManagersApprovalForm(
      enableConfigs,
      organization,
      approvingWaitingTime,
      [
        new HandlerToEventRequiringApprovalFields(
          {
            [enableReasonsToCancelAStop.name]: enableReasonsToCancelAStop,
            [enableReasonsToCancelAllStops.name]: enableReasonsToCancelAllStops
          },
          reasonsToCancelStops,
          enableAllReasonsToCancelStops
        ),
        new HandlerToEventRequiringApprovalFields(
          {
            [enableReasonsToUndeliverable.name]: enableReasonsToUndeliverable
          },
          reasonsToUndeliverable,
          enableAllReasonsToUndeliverable
        ),
        new HandlerToEventRequiringApprovalFields(
          {
            [enableReasonsToRedelivery.name]: enableReasonsToRedelivery
          },
          reasonsToRedelivery,
          enableAllReasonsToRedelivery
        )
      ]
    );

    App.Forms.ManagersApprovalRequestConfiguration.managersApprovalFormHandler = managersApprovalFormHandler;
    managersApprovalFormHandler.init();
  };

  validateReasonCodes = (lookupElement) => {
    const setCriteriaToGetUndeliverableCode = (criteria, type) => {
      const undeliverableCodes = criteria.criteriaChain[0].and.some(
        condition => condition.attr === 'type'
      );

      if (!undeliverableCodes) {
        const undeliverableCriteria = {
          attr: 'type',
          neq: type
        };
        criteria.criteriaChain[0].and.push(undeliverableCriteria);
      }
      return criteria;
    };

    const setOrganizationCriteria = (criteria) => {
      const filterByOrganization = criteria.criteriaChain[0].and.some(
        condition => condition.attr === 'organization.id'
      );

      if (!filterByOrganization) {
        const newCriteria = {
          attr: 'organization.id',
          eq: App.Forms.ManagersApprovalRequestConfigurationOrganizationLookup.lookupElement.getValue().id
        };
        criteria.criteriaChain[0].and.push(newCriteria);
      }
      return criteria;
    };
    if (lookupElement.filter.customNameSpace === 'ManagersApprovalRequestConfigurationReasonsToUndeliverableLookup') {
      lookupElement.filter.changeCriteriaBeforeFilter = criteria => setCriteriaToGetUndeliverableCode(setOrganizationCriteria(criteria), 'L');
    } else if (lookupElement.filter.customNameSpace === 'ManagersApprovalRequestConfigurationReasonsToRedeliveryLookup') {
      lookupElement.filter.changeCriteriaBeforeFilter = criteria => setCriteriaToGetUndeliverableCode(setOrganizationCriteria(criteria), 'U');
    } else {
      lookupElement.filter.changeCriteriaBeforeFilter = setOrganizationCriteria;
    }
  };

  onValidate = () => {
    const validation = App.Forms.ManagersApprovalRequestConfiguration.managersApprovalFormHandler.validation();
    if (!validation.isValid) {
      this.allow_submit.errorMessages = this.allow_submit.errorMessages.concat(validation.errorMessages);
      this.allow_submit.status = false;
    }
  };
}

App.Routers.ManagersApprovalRequestConfiguration = ManagersApprovalRequestConfigurationRouter;
